import { render, staticRenderFns } from "./hqglCarRegYearAudit.vue?vue&type=template&id=6be5389c&scoped=true&"
import script from "./hqglCarRegYearAudit.vue?vue&type=script&lang=js&"
export * from "./hqglCarRegYearAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be5389c",
  null
  
)

export default component.exports